import { Subject, Subscription, takeUntil } from 'rxjs';
import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DOC_STATE, SLA_DATA } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { SlaData } from 'src/app/models/documents.model';

@Component({
  standalone: false,
  selector: 'app-sla-data-input',
  templateUrl: './sla-data-input.component.html',
  styleUrl: './sla-data-input.component.scss'
})
export class SlaDataInputComponent {
  loading: boolean = true;
  destroy$ = new Subject<void>();
  current: number = 0;
  isMediumScreen: boolean = false;
  slaData: SlaData = {};
  private queryParamsSubscription!: Subscription;
  collectedData: SlaData = {};
  state: number = 2;
  isConfirmBack: boolean = false
  @Output() openModalConfirmBack = new EventEmitter<boolean>();
  serviceType: string = '';
  mode: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private BaseService: BaseService,
    private message: NzMessageService,
  ) {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.current = this.getCurrentStep(params);
      this.serviceType = params['service_type'];
      this.getSLAData()
    });

    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }


  private getCurrentStep(params: any): number {
    return params['step'] ? +params['step'] - 1 : 0;
  }

  getSLAData(): void {
    this.BaseService.getData(SLA_DATA + '/' + (this.serviceType === 'shipping' ? 'shipping_delivery' : 'payment_service'))
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res.data !== null) {
            this.slaData = res.data;
            this.mode = 'edit'
            localStorage.setItem('mode-sla-input', 'edit')
          } else {
            localStorage.setItem('mode-sla-input', 'create')
            this.mode = 'create'
            this.slaData = {}
          }
          this.loadLocalStorageData();
        },
        (err) => {
          this.message.create('error', 'Failed to fetch SLA data.');
        }
      );
  }

  loadLocalStorageData(): void {
    const storedData = localStorage.getItem('slaData');
    if (storedData) {
      const parsedStoredData = JSON.parse(storedData);
      this.slaData = { ...this.slaData, ...parsedStoredData };
      localStorage.setItem('slaData', JSON.stringify(this.slaData));
    }
  }

  back(): void {
    this.isConfirmBack = true
  }

  closeConfirmBack() {
    this.isConfirmBack = false
  }

  checkScreenSize(): void {
    this.isMediumScreen = window.innerWidth < 1200;
  }

  updateState(): void {
    const params = {
      document_type: 'SLA',
      state: this.state,
      service_types_id: this.serviceType === 'shipping' ? 1 : 2
    };
    this.BaseService.putData(DOC_STATE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          localStorage.removeItem('slaData');
          localStorage.removeItem('mode-sla-input');
          this.router.navigate(['/document']);
        },
        (err) => {
          this.message.error(err.error.meta.message || 'Failed to update state');
        }
      );
  }

  collectData(data: Partial<SlaData>): void {
    this.collectedData = {
      ...this.collectedData,
      ...data,
    };

    const storedData = localStorage.getItem('slaData');
    if (storedData) {
      const existingData = JSON.parse(storedData);
      this.collectedData = { ...existingData, ...this.collectedData };
    }

    this.slaData = { ...this.slaData, ...this.collectedData };
    localStorage.setItem('slaData', JSON.stringify(this.slaData));
  }


  submitFinal(): void {
    const serviceType = this.serviceType === 'shipping' ? 1 : 2;
    const data = {
      ...this.collectedData,
      service_types_id: serviceType
    }
    const request = this.mode === 'create'
      ? this.BaseService.postData(SLA_DATA, data) :
      this.BaseService.putData(SLA_DATA, data)
      request.pipe(takeUntil(this.destroy$))
        .subscribe(
          () => {
            this.message.create('success', 'SLA Data has been submitted successfully');
            this.state = 3;
            this.updateState();
          },
          (err) => {
            this.message.create('error', err.error?.data?.errors || 'Submission SLA Data Document failed, please check the completeness of the data.');
          }
        );
  }
}
